export default {
      id: "icon-arrow-right-2-usage",
      viewBox: "0 0 17.706 34.194",
      url: __webpack_public_path__ + "assets/template/sprite/sprite.svg#icon-arrow-right-2",
      toString: function () {
        return this.url;
      }
    }